import { render, staticRenderFns } from "./MatchReadPPopup.vue?vue&type=template&id=30fb7194&scoped=true"
import script from "./MatchReadPPopup.vue?vue&type=script&lang=js"
export * from "./MatchReadPPopup.vue?vue&type=script&lang=js"
import style0 from "./MatchReadPPopup.vue?vue&type=style&index=0&id=30fb7194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb7194",
  null
  
)

export default component.exports